import React, { useState, useEffect } from 'react'
import { connect, MapStateToProps } from 'react-redux'
import E3DButton from './E3DButton'
import {
    isGrpLoggedInSelector,
    isGrpLoginLoadingSelector,
    grpLoginStatusSelector,
} from '../../../redux/selectors/e3DGrpAuthSelectors'
import { State } from '../../../redux/reducers/rootReducer'
import configuredModelIdSelector from '../../../redux/selectors/models/configuredModelIdSelector'
import { useTranslation } from 'react-i18next'
import Modal, { ModalClosingButton } from '../../modal'
import E3DGrpLogin from '../e3d-grp-login/E3DGrpLogin'
import brandSelector from "../../../redux/selectors/brandSelector"

type StateProps = {
    isLoggedIn: ReturnType<typeof isGrpLoggedInSelector>
    isLoading: ReturnType<typeof isGrpLoginLoadingSelector>
    loginStatus: ReturnType<typeof grpLoginStatusSelector>
    configuredModelId: string
    brand: string
}

const mapStateToProps: MapStateToProps<StateProps, {}, State> = (state) => ({
    isLoggedIn: isGrpLoggedInSelector(state),
    isLoading: isGrpLoginLoadingSelector(state),
    loginStatus: grpLoginStatusSelector(state),
    configuredModelId: configuredModelIdSelector(state),
    brand: brandSelector(state),
})

const E3DButtonContainer: React.FC<StateProps & { setE3DSharingVisible: (visible: boolean) => void }> = ({
    isLoggedIn,
    isLoading,
    loginStatus,
    configuredModelId,
    setE3DSharingVisible,
    brand,
}) => {
    const { t } = useTranslation()
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
    const [wasLoginModalOpen, setWasLoginModalOpen] = useState(false)

    useEffect(() => {
        if (wasLoginModalOpen && isLoggedIn && !isLoading) {
            setIsLoginModalOpen(false)
            setWasLoginModalOpen(false)
            setE3DSharingVisible(true)
        }
    }, [isLoggedIn, isLoading, wasLoginModalOpen, setE3DSharingVisible])

    const openModal = () => {
        if (!isLoading) {
            if (isLoggedIn) {
                setE3DSharingVisible(true)
            } else {
                setIsLoginModalOpen(true)
                setWasLoginModalOpen(true)
            }
        }
    }

    const closeLoginModal = () => {
        setIsLoginModalOpen(false)
        setWasLoginModalOpen(false)
    }

    const isDisabled = isLoggedIn && !configuredModelId
    const tooltipText = isDisabled ? t('e3d.buttonTooltip') : ''

    return (
        <>
            <E3DButton
                isLoggedIn={isLoggedIn}
                isLoading={isLoading}
                loginStatus={loginStatus}
                openE3DModal={openModal}
                isDisabled={isDisabled}
                tooltipText={tooltipText}
                brand={brand}
            />
            {isLoginModalOpen && (
                <Modal isVisible={true} onClose={closeLoginModal}>
                    <ModalClosingButton onClick={closeLoginModal} />
                    <E3DGrpLogin />
                </Modal>
            )}
        </>
    )
}

export default connect(mapStateToProps)(E3DButtonContainer)
